var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExitFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.652,
    height: 21.435,
    viewBox: "0 0 21.652 21.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(0.261 0.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161088",
    "data-name": "Group 161088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M268.055,19.361a.572.572,0,0,1,.406.172l5.691,5.745a.572.572,0,1,1-.813.805l-5.69-5.744a.572.572,0,0,1,.406-.972",
    transform: "translate(-267.485 -19.361)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M273.354,19.012a.572.572,0,0,1,.572.572v5.76h-5.867a.572.572,0,1,1,0-1.144h4.724V19.584a.572.572,0,0,1,.572-.572",
    transform: "translate(-267.094 -18.253)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161089",
    "data-name": "Group 161089",
    transform: "translate(0 14.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M274.164,43.573a.572.572,0,0,1,.4.978l-5.746,5.69a.572.572,0,1,1-.805-.813l5.746-5.689a.572.572,0,0,1,.4-.166",
    transform: "translate(-267.843 -43.573)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M268.058,44.263h5.76V50.13a.572.572,0,1,1-1.144,0V45.407h-4.617a.572.572,0,1,1,0-1.144",
    transform: "translate(-266.724 -44.263)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161090",
    "data-name": "Group 161090",
    transform: "translate(14.257 13.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M292.981,43.123a.572.572,0,0,1,.406.172l5.69,5.743a.572.572,0,0,1-.813.805l-5.69-5.746a.572.572,0,0,1,.406-.972",
    transform: "translate(-292.409 -42.92)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M293.1,44.451h5.867a.572.572,0,0,1,0,1.144h-4.724v4.616a.572.572,0,0,1-1.144,0Z",
    transform: "translate(-293.1 -44.45)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161091",
    "data-name": "Group 161091",
    transform: "translate(14 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M298.28,19.01a.572.572,0,0,1,.4.978l-5.744,5.691a.572.572,0,0,1-.805-.813l5.747-5.691a.572.572,0,0,1,.4-.166",
    transform: "translate(-291.759 -19.011)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M293.858,19.011a.572.572,0,0,1,.572.572v4.723h4.616a.572.572,0,1,1,0,1.144h-5.76V19.583a.572.572,0,0,1,.572-.572",
    transform: "translate(-293.286 -18.617)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/Exit-Fullscreen.e1e3377f314cf92ec9edacf3a176df99.svg";
export { ForwardRef as ReactComponent };